export default __webpack_public_path__ + "static/media/electric-vehicle-gray.47c69f08.svg";